import { Link, useSearchParams } from "react-router-dom";
import { Section, Container, DisplayH1, Eyebrow } from "@/components/Layout";
import { CheckCircle2 } from "lucide-react";

export default function ApplyThankYou() {
  const [params] = useSearchParams();
  const id = params.get("id");
  return (
    <Section testid="apply-thanks" className="pt-40 pb-40">
      <Container>
        <div className="max-w-2xl">
          <CheckCircle2 size={40} className="text-[color:var(--wk-gold)]" />
          <Eyebrow className="mt-6">Application Received</Eyebrow>
          <DisplayH1 className="mt-6">We have your file.</DisplayH1>
          <p className="mt-8 text-lg text-[color:var(--wk-bone-dim)] leading-relaxed">
            Admissions officer <em className="text-[color:var(--wk-bone)]">Kwame Osei</em> will
            reach out within 48 hours to schedule your discovery call. Your reference number is
            <span className="ml-2 font-mono text-[color:var(--wk-gold)]">{id || "—"}</span>.
          </p>
          <div className="mt-10 flex gap-4">
            <Link to="/assistant" className="btn-ghost">Talk to TONIA</Link>
            <Link to="/" className="btn-gold">Return home</Link>
          </div>
        </div>
      </Container>
    </Section>
  );
}
